import BasketPage from './Basket.vue'


export default {
  routers() {
    return [
      {
        path: '/cart',
        name: 'cart',
        component: BasketPage
      },
    ];
  }
}





//////////////////
// WEBPACK FOOTER
// ./node_modules/redbay-b2b-basket/src/Router.js
// module id = IwOG
// module chunks = 0